import React, { useState } from 'react';
import { Mail, X } from 'lucide-react';
import EmailSubscriptionForm from './EmailSubscriptionForm';
import { isSubscribed } from '../../utils/subscription';
import { useTranslation } from 'react-i18next';
import { Modal } from '../common/Modal';

export default function EmailSubscriptionBanner() {
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  // Check if user has dismissed the banner or already subscribed
  const isDismissed = localStorage.getItem('emailBannerDismissed') === 'true';
  const subscribed = isSubscribed();

  if ((isDismissed || subscribed) && !showForm) {
    return null;
  }

  if (isMinimized && !showForm) {
    return (
      <div className="fixed bottom-4 right-4 z-40">
        <button
          onClick={() => setIsMinimized(false)}
          className="bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-colors"
          aria-label={t('subscription.showBannerAria', 'Show email subscription')}
        >
          <Mail className="h-6 w-6" />
        </button>
      </div>
    );
  }

  return (
    <>
      {/* Banner - Fixed to bottom */}
      {!showForm && (
        <div className="fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-r from-blue-600 to-blue-800 text-white py-4 px-6 shadow-lg">
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Mail className="h-6 w-6 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-lg">{t('subscription.bannerTitle', 'Stay Informed About Threats')}</h3>
                <p className="text-blue-100 text-sm">{t('subscription.bannerSubtitle', 'Get AI-powered threat intelligence delivered to your inbox')}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setShowForm(true)}
                className="bg-white text-blue-600 px-4 py-2 rounded-md font-medium hover:bg-blue-50 transition-colors"
              >
                {t('subscription.subscribe')}
              </button>
              <button
                onClick={() => setIsMinimized(true)}
                className="text-blue-200 hover:text-white p-1"
                aria-label={t('subscription.minimizeAria', 'Minimize')}
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Form using shared Modal with ESC/overlay close */}
      <Modal
        isOpen={showForm}
        onClose={() => setShowForm(false)}
        panelClassName="bg-transparent p-0 shadow-none max-w-md w-full"
      >
        <EmailSubscriptionForm />
      </Modal>
    </>
  );
}
